var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$isDataLoaded(_vm.course, _vm.groups))?_c('div',[_c('web-ide')],1):_vm._e(),_c('portal-target',{staticClass:"modal-portal",attrs:{"name":"modal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }